import { BranchMonthlyDeliveryPipeline } from './dashboard/widget/branch-monthly-delivery-pipeline';
import { BranchMonthlyRevenue } from './dashboard/widget/branch-monthly-revenue';
import { BranchMonthlyRevenuePipeLine } from './dashboard/widget/branch-monthly-revenue-pipeline';
import { BranchQuoteConversationView } from './conversation/wm-branchquote-conversation';
import { DashboardFilter } from './dashboard/widget/dashboard-filter';
import { GeneratedPurchaseOrdersWidget } from './dashboard/widget/generated-purchase-orders-widget';
import { GeneratedQuotesWidget } from './dashboard/widget/issued-quotes-widget';
import { SalesSuccessWidget } from './dashboard/widget/sales-success-widget';
import { WebModuleBranchQuoteConversationEditor } from './conversation/wm-branchquote-support-editor';
import { WebModuleBranchQuoteSupportNew } from './conversation/wm-branchquote-support-new';
import {
  WebModuleConversationEntryCreate,
  WebModuleConversationEntryEditorView,
  WebModuleConversationEntryView,
  WebModuleConversationUsersView
} from './conversation/wm-conversation-entry';
import { WebModuleConversationEntryDropZone } from './conversation/wm-conversation-entry-dropzone';
import { WebModuleFranchiseeBranchEditor } from '../franchisee/editors/franchisee-branch-editor';
import { WebModuleFranchiseeBranchesEditor } from '../franchisee/editors/franchisee-branches-editor';
import { WebModuleFranchiseeETOEditor } from './quotes/views/franchisee-engineered-to-order';
import { WebModuleQuoteSupportInboxView } from './conversation/wm-branchquote-support';

export const franchiseeComponentRegistry = {
  branchEditor: WebModuleFranchiseeBranchEditor,
  branchesEditor: WebModuleFranchiseeBranchesEditor,
  supportEditor: BranchQuoteConversationView,
  supportInboxView: WebModuleQuoteSupportInboxView,
  conversationEntryView: WebModuleConversationEntryView,
  conversationEntryEditor: WebModuleConversationEntryEditorView,
  conversationEntryCreate: WebModuleConversationEntryCreate,
  conversationUsers: WebModuleConversationUsersView,
  newSupportView: WebModuleBranchQuoteSupportNew,
  conversationEntryDropZone: WebModuleConversationEntryDropZone,
  webModuleFranchiseeETOEditor: WebModuleFranchiseeETOEditor,
  webModuleBranchQuoteConversationEditor: WebModuleBranchQuoteConversationEditor,
  dashboardFilterControls: DashboardFilter,
  dashboardBranchMonthlyDeliveryPipeline: BranchMonthlyDeliveryPipeline,
  dashboardBranchMonthlyRevenue: BranchMonthlyRevenue,
  dashboardBranchMonthlyRevenuePipeLine: BranchMonthlyRevenuePipeLine,
  dashboardSalesSuccessWidget: SalesSuccessWidget,
  dashboardGeneratedPurchaseOrderWidgets: GeneratedPurchaseOrdersWidget,
  dashboardGeneratedQuotesWidget: GeneratedQuotesWidget
};
